import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosPublicRequest, saveToken } from "request/request";
import { customToasts } from "global/customToast";

export const loginApi = createAsyncThunk(
  "user/login",
  async ({ navigate, ...body }, { rejectWithValue }) => {
    try {
      let url = `auth/v1/login`;
      const { data } = await axiosPublicRequest.post(url, body);
      if (!data.hasOwnProperty("error")) {
        const curentRole = data?.user_data?.roles?.[0];

        saveToken(data?.access_token, data?.refresh_token);
        sessionStorage.setItem("userRole", curentRole);
        sessionStorage.setItem("userData", JSON.stringify(data?.user_data));
        navigate("/");
        window.location.reload();
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const forgotPasswordApi = createAsyncThunk(
  "user/forgotPasswordApi",
  async ({ closeModal, ...body }, { rejectWithValue }) => {
    try {
      let url = `auth/v1/forgot-password`;
      const { data } = await axiosPublicRequest.put(url, body);
      if (!data.hasOwnProperty("error")) {
        customToasts.success(data.message);
        closeModal();
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
